module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/63b8962ea3c519d3b4fa7fb00a166f50.png";